const path = require('path');

const formColumnWidth = 313;
const formColumnMargin = 88;
const formFieldTooltipWidth = 18;
const formFieldTooltipLeftPadding = 10;

module.exports = {
  frontendSrcDir: path.resolve(__dirname, '../..'),
  mobileBreakPoint: '479px', /* <= 479 */
  smallTabletBreakPoint: '767px', /* 479 < x <= 767 */
  tabletBreakPoint: '1024px', /* <= 1024 */
  // desktop > 1024

  form_columnWidth: `${formColumnWidth}px`,
  form_fieldTooltipWidth: `${formFieldTooltipWidth}px`,
  form_fieldTooltipLeftPadding: `${formFieldTooltipLeftPadding}px`,
  form_columnWithTooltipWidth: `${formColumnWidth + formFieldTooltipWidth + formFieldTooltipLeftPadding}px`,
  form_columnMargin: `${formColumnMargin}px`,
  form_columnWithTooltipMargin: `${formColumnMargin - formFieldTooltipWidth - formFieldTooltipLeftPadding}px`,
  form_2ColumnsWidth: `${(formColumnWidth * 2) + formColumnMargin}px`,

  modalWithTwoColumnsWidth: '804px',

  // colors
  color_warmGray: '#8e8e8e',

  color_statusApproved: '#23bd0b',
  color_statusDeleted: '#555555',
  color_statusPending: '#cd994f',
  color_statusCanceled: '#ff0000',
  color_statusSuspended: '#ee6315',

  leftAndRightPaddingForMobile: '11px', /* < 480px */
  leftAndRightPaddingForTablet: '22px', /* 480px <= x <= 1024 */
  leftAndRightPaddingForDesktop: '33px', /* > 1024 */
};
